//Get yearly value
//get Value
//default values
//Sources

import {
    EBITDAFieldsKeys,
    FieldsSchema,
    SchemaFieldKeys
} from '@assets/model/FieldsSchema';
import { getFloat, getInt } from '@assets/utils/Formatting';
import { get_numbers } from '@assets/utils/Utils';
import assert from 'assert';
import _, { isString } from 'lodash';
import {
    PanelColumn,
    PanelRow,
    TableField
} from '../component/Panel/PanelTable/PanelTable';

import { ScoreUtils, SectionNameTypes } from './ScoreUtils';

//NOTE: All the .indexOf ('.') is for the future of having section'ed data and not flat data
//Didn't add it now to avoid stability issues as we don't have time

// type FieldType = '$' | '%' | 'str' | 'bool' | 'array' | 'int';
// type FieldInfo = {
//     display: string;
//     type: FieldType;
//     yearly?: boolean;
// }

// const ebitdaSection = {
//     "unadjusted_ebitda": { display: "Unadjusted EBITDA", type: "$", yearly: true },
//     "pro_forma_ebitda": { display: "Pro Forma EBITDA", type: "$", yearly: true },
//     "adjusted_ebitda": { display: "Adjusted EBITDA", type: "$", yearly: true },
//     "runrate_adjusted_ebitda": { display: "Runrate Adjusted EBITDA", type: "$", yearly: true },
//     "annualized_adjusted_ebitda": { display: "Annualized Adjusted EBITDA", type: "$", yearly: true }
// } as const;

// const DATA_SECTIONS = {
//     "ebitda": ebitdaSection
// } as const;

// export type DataSectionKey = keyof typeof DATA_SECTIONS;
// //export type DataFieldsKey<T extends DataSectionKey> = keyof SectionsTypeLiteral[T];
// export type DataFieldsKey<T extends DataSectionKey> = keyof typeof DATA_SECTIONS[T];

// export type SectionFieldRequest = {
//     [K in DataSectionKey]: {
//         section: K;
//         field: DataFieldsKey<K>;
//     };
// }[DataSectionKey];

// export type SectionValueByYearRequest = {
//     [K in DataSectionKey]: {
//         section: K;
//         field: DataFieldsKey<K>;
//         year?: number;
//     };
// }[DataSectionKey];

type RevenuePerYear = {
    year?: number;
    revenue: number;
};

type EbitdPerYear = {
    year?: number;
    ebitda: number;
    type: EBITDAFieldsKeys;
};
export interface Customer {
    name: string;
    revenue?: RevenuePerYear[];
    percentageOfRevenue?: number;
    tenure?: number;
    page_sources?: number[];
}

export class DataAccessUtils {
    //Order of selected ebitda top is most 'adjusted'
    static readonly EBITDA_TYPES: EBITDAFieldsKeys[] = [
        'adjusted_ebitda_per_year',
        'ebitda_per_year'
    ];
    private report: any;
    private _scoreCache: number = null;

    constructor(
        reportOriginal: any,
        private overrides: any,
        private reportId: string
    ) {
        this.report = _.cloneDeep(reportOriginal);
        if (!this.report) {
            return null;
        }

        var over_rides = overrides;
        for (var fieldName in over_rides) {
            const value = over_rides[fieldName];
            //typeof a == 'object' && Array.isArray(a)\
            //Connect to field type in schmea to know sub field
            const fieldsSchema = FieldsSchema;

            if (typeof value == 'object') {
                if (!Array.isArray(value)) {
                    var set = value as {};

                    if (!Array.isArray(this.report[fieldName])) {
                        this.report[fieldName] = [];
                    }

                    const keys = Object.keys(set);
                    keys.forEach(year => {
                        const yearValue = set[year];
                        // if (fieldName.indexOf(".") > 0) {
                        //     const { section, field } = this.getSectionFieldFromSource(fieldName);
                        //     const fieldsSchema = DATA_SECTIONS[section];
                        // }
                        if (!fieldsSchema.hasOwnProperty(fieldName)) {
                            console.log(
                                `Field ${fieldName} not found in schema`
                            );
                            return;
                        }
                        // assert(
                        //     fieldsSchema.hasOwnProperty(fieldName),
                        //     `Field ${fieldName} not found in schema`
                        // );
                        const subFieldName = fieldsSchema[fieldName].field;

                        const e = this.report[fieldName].find(arrYear => {
                            return parseInt(arrYear.year) == parseInt(year);
                        });

                        const entry = {
                            year: parseInt(year),
                            [subFieldName]: yearValue
                        };

                        if (!e) {
                            this.report[fieldName].push(entry);
                        } else {
                            e[subFieldName] = yearValue;
                        }
                    });
                }
            } else {
                const fieldMeta = fieldsSchema[fieldName];
                if (fieldMeta && fieldMeta.t == 'array') {
                    var unpack = value.split(',');
                    var toInt = unpack.map(v => getInt(v));
                    this.report[fieldName] = toInt;
                } else {
                    this.report[fieldName] = value;
                }
            }
        }
    }

    isValueEditedByRowCol(row: PanelRow, col: PanelColumn) {
        const schema = FieldsSchema;
        const edits = this.overrides;
        const fieldName = row.field.source;
        // if (fieldName.indexOf(".") > 0) {
        //     const parts = fieldName.split(".");
        //     var sectionName = parts[0] as DataSectionKey;
        //     var subField = parts[1] as DataFieldsKey<DataSectionKey>;
        //     const sectionDefinition = DATA_SECTIONS[sectionName];
        //     const field = sectionDefinition[subField];
        //     const editKey = `${sectionName}.${subField}`;

        //     if (field.yearly) {
        //         if (!edits.hasOwnProperty(editKey)) {
        //             return false;
        //         }
        //         if (!edits[editKey].hasOwnProperty(col.column.source.toString())) {
        //             return false;
        //         }

        //         return true;
        //     } else {
        //         return edits && edits.hasOwnProperty(editKey);
        //     }
        // }

        const f = schema[row.field.source];
        if (f.yearly) {
            if (!edits.hasOwnProperty(row.field.source)) {
                return false;
            }
            if (
                !edits[row.field.source].hasOwnProperty(
                    col.column.source.toString()
                )
            ) {
                return false;
            }

            return true;
        } else {
            //value
            return edits && edits.hasOwnProperty(row.field.source);
        }
    }

    isValueEditedAtAll(fieldName: string) {
        const edits = this.overrides;
        return edits && edits.hasOwnProperty(fieldName);
    }

    get activeReport() {
        return this.report;
    }

    get customers() {
        const v = this.value('top_customers');
        if (v == 'N/A') {
            return null;
        }

        return v as Customer[];
    }

    get selectedEbitdaType(): EBITDAFieldsKeys {
        var availEbitda: EBITDAFieldsKeys[] = [];
        for (const ebitdaType of DataAccessUtils.EBITDA_TYPES) {
            if (this.report[ebitdaType]) {
                availEbitda.push(ebitdaType);
            }
        }

        if (availEbitda.length == 0) {
            return 'ebitda_per_year';
        }

        const getTotal = key => {
            return this.report[key].length;
        };
        const options = availEbitda.slice(0, 2);
        if (options.length > 1) {
            const totalBest = getTotal(options[0]);
            const totalSecond = getTotal(options[1]);
            if (totalBest >= totalSecond - 2) {
                //Still pick #1 if its only 2 less than #2
                return options[0];
            } else {
                return options[1];
            }
        } else {
            return options[0];
        }
    }

    value(fieldName: string) {
        let data = this.report;
        if (!data) return 'N/A';

        if (data.hasOwnProperty(fieldName)) {
            var field = FieldsSchema[fieldName];
            var val = data[fieldName];
            if (field && field.t == 'bool') {
                if (typeof val === 'string') {
                    return val === 'true' ? true : false;
                }
            }
            return data[fieldName];
        }

        return 'N/A';
    }

    actualYear() {
        const actualizedYears =
            this.report['list_years_actualized_revenue'] ?? [];

        if (actualizedYears.length == 0) {
            (this.report['net_revenue_per_year'] ?? []).forEach((item: any) => {
                actualizedYears.push(parseInt(item.year));
            });
        }
        return Math.max(...actualizedYears);
    }

    valueByYearDivideByRevenue(
        fieldName: string,
        year: number,
        yearOffset: number = 0
    ) {
        let data = this.report;
        if (!data) {
            return 'N/A';
        }
        try {
            const fieldValue = this.valueByYear(
                fieldName as SchemaFieldKeys,
                year,
                yearOffset
            );
            const revenue = this.valueByYear(
                'net_revenue_per_year',
                year,
                yearOffset
            );
            return fieldValue / revenue;
        } catch {
            return 'N/A';
        }
    }

    getIsYearActualized(year: number) {
        const actualizedYears =
            this.value('list_years_actualized_revenue') ?? [];
        const minActualizedYear = Math.min(...actualizedYears);
        const isActualized =
            actualizedYears.includes(year) || year <= minActualizedYear;

        return isActualized;
    }

    getReportYearRange() {
        var minYear = -1;
        var maxYear = -1;
        const fields = ['net_revenue_per_year', 'ebitda_per_year'];
        var data = this.activeReport;

        fields.forEach(field => {
            const list = data[field];
            if (!list || Array.isArray(list) === false) {
                return;
            }
            const years = list.map((item: any) => parseInt(item.year));
            const min = Math.min(...years);
            const max = Math.max(...years);
            if (minYear == -1 || min < minYear) {
                minYear = min;
            }
            if (maxYear == -1 || max > maxYear) {
                maxYear = max;
            }
        });

        return { from: minYear, to: maxYear };
    }

    valueByYear(
        fieldName: SchemaFieldKeys,
        year: number,
        yearOffset: number = 0
    ) {
        // if (fieldName.indexOf(".") > 0) {
        //     const { section, field } = this.getSectionFieldFromSource(fieldName);
        //     return this.valueBySection({ section, field, year: year + yearOffset });
        // }

        let data = this.report;
        if (!data) {
            return 'N/A';
        }

        const fieldInfo = FieldsSchema[fieldName];
        assert(fieldInfo, `Field ${fieldName} not found in schema`);
        assert(
            fieldInfo.hasOwnProperty('field'),
            `Field ${fieldName} does not have 'field' property`
        );

        const valueField = fieldInfo['field'];

        const yearSource = year + yearOffset;
        const dataRow = data[fieldName];

        if (!dataRow || !Array.isArray(dataRow)) {
            return 'N/A';
        }

        const r = dataRow.find((d: any) => parseInt(d.year) === yearSource);
        if (r == undefined) {
            return 'N/A';
        }

        if (r.hasOwnProperty(valueField)) {
            return r[valueField];
        } else {
            return 'N/A';
        }
    }

    // BY SECTION CODE TO USE SOMETIME
    // getSectionFieldFromSource(fieldName: string) {
    //     const parts = fieldName.split('.');
    //     assert(parts.length == 2, `Invalid field name ${fieldName}`);
    //     const section = parts[0] as DataSectionKey;
    //     const field = parts[1] as DataFieldsKey<DataSectionKey>;
    //     return { section, field };
    // }
    // schemaBySection(request: SectionFieldRequest): FieldInfo {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     return sectionDefinition[request.field];

    // }
    // labelBySection(request: SectionFieldRequest) {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     const field = sectionDefinition[request.field];
    //     return field.display;
    // }

    // sourcesBySection(request: SectionFieldRequest): number[] {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     const data = this.report[request.section];

    //     if (!data) {
    //         return [];
    //     }

    //     const field = sectionDefinition[request.field];
    //     const sourcesField = request.field + '_sources';
    //     const sourcesValue = data[sourcesField];
    //     var sources = [];
    //     if (sourcesValue) {
    //         sources = get_numbers(sourcesValue.toString());
    //     }

    //     return sources;
    // }

    // valueBySection(request: SectionValueByYearRequest) {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     const data = this.report[request.section];
    //     const field = sectionDefinition[request.field];

    //     const ret = (val) => {
    //         return val;
    //     }

    //     const retNA = () => {
    //         return "N/A";
    //     }

    //     if (!data) {
    //         return retNA();
    //     }

    //     if (field.yearly && !request.year) {
    //         console.log(`Field ${request.field} is yearly, but year is not provided`);
    //         return retNA();
    //     }

    //     if (field.yearly) {
    //         const year = request.year;
    //         const fieldList = data[request.field];
    //         if (!fieldList) {
    //             return retNA();
    //         }
    //         const yearData = fieldList.find((d: any) => parseInt(d.year) === year);
    //         if (yearData) {
    //             const val = yearData[request.field]; //always same key
    //             if (val == undefined) {
    //                 return retNA();
    //             }

    //             return ret(val);
    //         }
    //     } else {
    //         const fieldValue = data[request.field];
    //         if (fieldValue == undefined) {
    //             return retNA();
    //         }
    //         return ret(fieldValue);
    //     }
    // }
    organicCagr(howManYears: number) {
        try {
            const q = this;
            const lastYear = q.actualYear();
            const current = q.valueByYear('net_revenue_per_year', lastYear);
            const before = q.valueByYear(
                'net_revenue_per_year',
                lastYear,
                -howManYears
            );

            if (current == 'N/A' || before == 'N/A') {
                return 'N/A';
            }
            return (current / before) ** (1 / howManYears) - 1;
        } catch {
            return 'N/A';
        }
    }

    ebitdaMargin(year: number) {
        const ebitda = this.valueByYear('ebitda_per_year', year);
        const revenue = this.valueByYear('net_revenue_per_year', year);
        if (ebitda === 'N/A' || revenue === 'N/A') {
            return 'N/A';
        }

        return ebitda / revenue;
    }

    selectedEbitda(year: number) {
        const selectedEbitdaType = this.selectedEbitdaType;
        return this.valueByYear(selectedEbitdaType, year);
    }

    selectedEbitdaMargin(year: number) {
        const ebidtaType = this.selectedEbitdaType;
        const ebitda = this.selectedEbitda(year);
        const revenue = this.valueByYear('net_revenue_per_year', year);
        if (ebitda === 'N/A' || revenue === 'N/A') {
            return 'N/A';
        }

        return ebitda / revenue;
    }
    //Merge the two
    projectedCagr(howManYears: number) {
        try {
            const q = this;
            const lastYear = q.actualYear();
            const current = q.valueByYear('net_revenue_per_year', lastYear);
            const projected = q.valueByYear(
                'net_revenue_per_year',
                lastYear,
                howManYears
            );

            if (current == 'N/A' || projected == 'N/A') {
                return 'N/A';
            }
            return (projected / current) ** (1 / howManYears) - 1;
        } catch (e) {
            return 'N/A';
        }
    }

    fcf_conversion_ebitda(year: number) {
        const ebitda = this.selectedEbitda(year);

        const capex = this.valueByYear('capex_per_year', year);

        if (ebitda === 'N/A' || capex === 'N/A') {
            return 'N/A';
        }

        return (ebitda - capex) / ebitda;
    }

    formatExtendedValueDisplay(input: string) {
        var display = input;
        const matches = display.match(/%[A-Z0-9_]+%/g) || [];
        const stripped = matches.map(m => m.slice(1, -1));
        for (const match of stripped) {
            switch (match) {
                case 'SELECTED_EBITDA':
                    const selected = this.selectedEbitdaType;
                    const schemaLookupName =
                        FieldsSchema[selected]['display'] ?? 'Adjusted EBITDA';
                    display = display.replace(`%${match}%`, schemaLookupName);
                    break;
            }
        }

        return display;
    }
    get_extended_value_float(fieldName: string) {
        var val = this.get_extended_value_float_internal(fieldName);
        if (isString(val)) {
            val = val.replace('%', '');
        }

        //Hack
        if (
            fieldName == 'recurring_revenue_summary' ||
            fieldName == 'organic_cagr_N_years' ||
            fieldName == 'projected_organic_cagr_N_years' ||
            fieldName == 'extended_selected_ebitda'
        ) {
            return val;
        }

        if (val === 'N/A' || isNaN(val) || val === '' || val === 'NaN') {
            return 'N/A';
        }

        return getFloat(val);
    }

    get_extended_value_float_internal(fieldName: string) {
        switch (fieldName) {
            case 'extended_selected_ebitda':
                const selected = this.selectedEbitdaType;
                const schemaLookupName =
                    FieldsSchema[selected]['display'] ?? 'Adjusted EBITDA';
                return schemaLookupName;

            case 'organic_cagr_N_years':
                var ret = {};
                for (var years = 5; years >= 3; years--) {
                    ret[years] = this.organicCagr(years);
                }
                return ret;
            case 'projected_organic_cagr_N_years':
                var ret = {};
                for (var years = 5; years >= 3; years--) {
                    ret[years] = this.projectedCagr(years);
                }
                return ret;
            case 'organic_cagr_4_years':
                return this.organicCagr(4);
            case 'organic_cagr_3_years':
                return this.organicCagr(3);
            case 'projected_organic_cagr_3_years':
                return this.projectedCagr(3);
            case 'projected_organic_cagr_4_years':
                return this.projectedCagr(4);
            case 'projected_organic_cagr_N_years_minus_tam_growth':
                var projected = null;
                for (var years = 5; years >= 3; years--) {
                    projected = this.projectedCagr(years);
                    if (projected !== 'N/A') {
                        break;
                    }
                }

                var market_growth = this.value('projected_market_growth');
                if (projected === 'N/A' || market_growth === 'N/A') {
                    return 'N/A';
                }

                //Market growth is 1-100, not 0-1
                return (projected as number) - getFloat(market_growth) / 100.0;

            case 'adj_ebitda_margin':
                return this.selectedEbitdaMargin(this.actualYear());
            case 'adj_ebitda_margin_trend':
                const ebitdaNow = this.selectedEbitdaMargin(this.actualYear());
                const ebitda2YearsAgo = this.selectedEbitdaMargin(
                    this.actualYear() - 2
                );
                if (ebitdaNow === 'N/A' || ebitda2YearsAgo === 'N/A') {
                    return 'N/A';
                }

                return ebitdaNow - ebitda2YearsAgo;

            case 'adj_ebitda':
                return this.selectedEbitda(this.actualYear());

            case 'gross_retention':
                const gross = this.valueByYear(
                    'gross_retention_lost_only_per_year',
                    this.actualYear()
                );

                if (gross === 'N/A') {
                    return 'N/A';
                }
                return gross / 100;

            case 'net_retention':
                return this.valueByYear(
                    'net_retention_yearly',
                    this.actualYear()
                );

            case 'revenue_latest':
                return this.valueByYear(
                    'net_revenue_per_year',
                    this.actualYear()
                );

            case 'ebitda_magnatitude_adjustment':
                const ebitda = this.valueByYear(
                    'ebitda_per_year',
                    this.actualYear()
                );
                const adj_ebitda = this.selectedEbitda(this.actualYear());

                return (adj_ebitda - ebitda) / adj_ebitda;
            case 'fcf_conversion_ebitda':
                return this.fcf_conversion_ebitda(this.actualYear());
            case 'nwc_as_percent_of_revenue':
                const currentAssets = this.valueByYear(
                    'total_current_assets_yearly',
                    this.actualYear()
                );
                const currentLiabilities = this.valueByYear(
                    'total_current_liabilities_yearly',
                    this.actualYear()
                );
                const revenue = this.valueByYear(
                    'net_revenue_per_year',
                    this.actualYear()
                );
                if (
                    currentAssets === 'N/A' ||
                    currentLiabilities === 'N/A' ||
                    revenue === 'N/A'
                ) {
                    return 'N/A';
                }
                return (currentAssets - currentLiabilities) / revenue;
            case 'free_cash_flow_conversion':
                const ebitdaCashFlow = this.valueByYear(
                    'ebitda_per_year',
                    this.actualYear()
                );
                const maintenance_capex = this.valueByYear(
                    'maintenance_capex_per_year',
                    this.actualYear()
                );
                if (ebitdaCashFlow === 'N/A' || maintenance_capex === 'N/A') {
                    return 'N/A';
                }

                return (ebitdaCashFlow - maintenance_capex) / ebitdaCashFlow;
            case 'total_capex_by_rev':
                const capex = this.valueByYear(
                    'capex_per_year',
                    this.actualYear()
                );
                const revenueCapex = this.valueByYear(
                    'net_revenue_per_year',
                    this.actualYear()
                );
                if (capex === 'N/A' || revenueCapex === 'N/A') {
                    return 'N/A';
                }
                return capex / revenueCapex;

            case 'gross_profit_margin':
                const grossProfit = this.valueByYear(
                    'gross_profit_per_year',
                    this.actualYear()
                );
                const revenueGross = this.valueByYear(
                    'net_revenue_per_year',
                    this.actualYear()
                );
                if (grossProfit === 'N/A' || revenueGross === 'N/A') {
                    return 'N/A';
                }
                return grossProfit / revenueGross;

            case 'gross_profit':
                return this.valueByYear(
                    'gross_profit_per_year',
                    this.actualYear()
                );

            case 'total_addressable_market':
            case 'historical_market_growth':
            case 'projected_market_growth':
            case 'recurring_revenue_summary':
                return this.value(fieldName);
            default:
                return null;
        }
    }

    scoreBySection(sectionName: SectionNameTypes) {
        const scoreUtil = new ScoreUtils(this);
        if (scoreUtil.is_section_used_for_scoring_by_id(sectionName)) {
            return scoreUtil.calcSectionPercentileById(sectionName);
        } else {
            return null;
        }
    }

    score() {
        if (this._scoreCache != null) {
            return this._scoreCache;
        }

        const scoreUtil = new ScoreUtils(this);
        const score = scoreUtil.calcScorePercentile();

        if (score == null) {
            this._scoreCache = -1;
        } else {
            this._scoreCache = Math.round(score * 100);
        }

        return this._scoreCache;
    }

    sourcesByField(fieldName: string, fieldDisplay: string) {
        // if (fieldName && fieldName.indexOf(".") > 0) {
        //     const parts = fieldName.split(".");
        //     var sectionName = parts[0];
        //     var fieldName = parts[1];
        //     return this.sourcesBySection({ section: sectionName as any, field: fieldName as any });
        // }

        let fields = [fieldName];
        if (fieldDisplay == '⁠Capitalized Development Costs') {
            if (
                this.value('capitalized_software_override_page_source') != 'N/A'
            ) {
                fields = ['capitalized_software_override'];
            } else {
                fields = [
                    'capitalized_software',
                    'capitalized_application_development',
                    'capitalized_rnd'
                ];
            }
        }

        const conv_source_to_num_array = (sourcesValue: any) => {
            var pages = get_numbers(sourcesValue.toString());
            return pages;
        };

        var sources = [];
        fields.forEach(fieldEntry => {
            let val = this.value(fieldEntry + '_page_source');
            sources = sources.concat(conv_source_to_num_array(val));
        });

        return sources;
    }

    anyValue(fieldName: SchemaFieldKeys) {
        const field = FieldsSchema[fieldName];
        if (field['yearly'] ?? false) {
            const data = this.report[fieldName];
            if (!data) {
                return false;
            }
            return Object.keys(data).length > 0;
        } else {
            return this.report.hasOwnProperty(fieldName);
        }
    }
    sources(field: TableField, column: TableField) {
        let l = this.sourcesByField(field.source, field.display);
        l = l.sort((a, b) => a - b);
        return _.uniq(l);
    }

    get pdfViewUrl() {
        return this.value('pdfViewUrl');
    }

    get companyName() {
        return this.value('company_name');
    }
}
